<template>
    <admin-layout class="tenants">

        <app-content-pane class="ml-3">

            <template #title>
                <div class="px-4 pt-3">
                    <h1>Social Change Podcasts</h1>
                    <p>
                        Spark empathy, open intelligent discussion, and drive students to become
                        changemakers by introducing them to real stories about relevant social
                        issues through our podcast episodes.
                    </p>
                </div>
            </template>

            <hr class="my-0">

            <section class="embed">
                <iframe :src="url" class="frame" ref="frame"></iframe>
            </section>

        </app-content-pane>

    </admin-layout>
</template>

<script>
import AppContentPane from "@/Components/AppContentPane";
import AdminLayout from "@/Layouts/AdminLayout";
export default {
    name: "EmbedIndex",
    components: {AdminLayout, AppContentPane},

    computed: {
        frame(){
            return this.$refs.frame;
        },

        url(){
            return 'https://www.designforchange.us/podcasts-embed';
        },
    },

    methods: {
        resizeFrame(){
            setTimeout(() => {
                this.frame.height = '1500px';
            }, 100);
        },
    },

    mounted() {
        this.frame.addEventListener('load', this.resizeFrame);
        this.frame.addEventListener('resize', this.resizeFrame);
    },

    beforeUnmount() {
        this.frame.removeEventListener('load', this.resizeFrame);
        this.frame.removeEventListener('resize', this.resizeFrame);
    },

    mounted() {
        this.setTitle("Social Change Podcasts");
    }

}
</script>
<style lang="scss" scoped>
.embed{
    font-size: 0;
}
.frame{
    width: 100%;
    border: none;
    border-radius: 0 0 6px 6px;
    height:  3000px;
}
</style>
